// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Iuf0","col":"styles_col__3xfCb"};